<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates33">
<p class="centerImage"><img alt="images" id="plate33" src="images/plate33.jpg"/></p>
<p class="caption">Bob Ashby trying to look interested, 2nd left, while playing cricket at dispersal.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates33.vue?2e8837e6